import $ from "jquery"

function initHomeSwiper() {
  function collectCaptions() {
    const $slides = $(".swiper").find(".swiper-slide");
    const captions = $slides.map(function() {
      const $slide = $(this);
      const $tplcaption = $slide.find("template.caption");
      if($tplcaption.length == 0) {
        return "";
      } else {
        const caption = $tplcaption.html().trim();
        return caption;
      }
    });
    return captions;
  }

  const captions = collectCaptions();

  const swiperConfig = {
    loop: true,
    autoHeight: false,
    spaceBetween: 20,    

    navigation: {
      nextEl: '.btnnext',
      prevEl: '.btnprev',
    },
  
    slidesPerView: 'auto',

    keyboard: {
      enabled: true
    }
  };

  if(window.innerWidth < 768) {
    //https://swiperjs.com/swiper-api#free-mode
    swiperConfig.freeMode = {
      enabled: true,
      sticky: false
    };
  }

  const swiper = new Swiper('.swiper', swiperConfig);
  const $projectlabel = $(".projectlabel");
  function updateProjectLabel(slideidx) {
    const caption = captions[slideidx];
    $projectlabel.html(caption);
  }
  swiper.on("slideChange", function(ev) {
    const slideidx = swiper.realIndex; //auch: ev.realIndex
    updateProjectLabel(slideidx);
  });
  updateProjectLabel(0);
}

$(function() {
  const $body = $("body");
  if($body.hasClass("tplhome")) {
    initHomeSwiper();
  }
});
